import React, { useState, useEffect } from 'react';

//UTILS
import { useNavigate } from 'react-router-dom';
import AdminService from '../../services/admin_services';
import TokenService from '../../services/token_services';
import { TOAST_OPTIONS, EXPLORER } from '../../constants';

//VISUALS
import LOGO_BLACK from '../../assets/images/logo_black.png'

//COMPONENTS
import Menu from '../../components/menu/admin';
import BoardHeader from '../../components/boardheader/admin';
import Button from '../../components/button';
import { ToastContainer, toast } from 'react-toastify';
import { ThreeDots } from 'react-loader-spinner';

//TRANSLATION
import { useTranslation } from 'react-i18next';

const AdminOrders = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [pending, setPending] = useState(true);
    const [orders, setOrders] = useState(null);
    const [users, setUsers] = useState({});
    const [loading, onChangeLoading] = useState(false);
    const [amount, setAmount] = useState("");
    const [displayValidation, setDisplayValidation] = useState(null);

    const shortHash = (value) => {
        if (!value) return '-';
        if (value.length <= 22) return value;
        return `${value.substring(0, 4)}...${value.substring(value.length - 8)}`;
    }

    const formatDate = (value) => {
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '-';
        return date.toLocaleDateString();
    }

    const loadOrders = async () => {
        setOrders(null)
        let ords = await AdminService.listOrders(pending);
        setOrders(ords.orders);
        setUsers(ords.user_info);
    }

    const toggleValidation = (uuid) => {
        setDisplayValidation(displayValidation === uuid ? null : uuid)
    }

    const validateOrder = async (user_uuid) => {
        if (!amount || amount === "-" || (parseInt(amount) < 10))
            toast.error(t('transfer.invalid_amount') + ' Min. 10 €', TOAST_OPTIONS)
        else {
            onChangeLoading(true)
            if (window.confirm(t('admin.confirm_order'))) {
                try {
                    const resp = await AdminService.validateOrder(user_uuid, displayValidation, parseInt(amount))
                    if (resp.status) {
                        setAmount("")
                        setTimeout(() => {
                            onChangeLoading(false)
                            setDisplayValidation(null)
                            toast.success(t('admin.order_validated'), TOAST_OPTIONS)
                            loadOrders()
                        }, 10000)
                    } else {
                        toast.error(resp.message, TOAST_OPTIONS)
                        onChangeLoading(false)
                    }
                } catch (e) {
                    onChangeLoading(false)
                    console.log(e.response.data)
                    toast.error(e.response && e.response.data ? t(e.response.data.message) : t(e.message), TOAST_OPTIONS)
                }
            }
        }
    }

    useEffect(() => {
        // Prevent page caching
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', handleBackButton);
        
        // Check authentication
        if (!TokenService.isUser()) {
            navigate('/admin/signin', { replace: true });
            return;
        }
        
        loadOrders();
        
        return () => {
            window.removeEventListener('popstate', handleBackButton);
        };
        // eslint-disable-next-line
    }, [pending]);

    const handleBackButton = () => {
        if (!TokenService.isUser()) {
            navigate('/admin/signin', { replace: true });
        } else {
            window.history.pushState(null, null, window.location.pathname);
        }
    };


    return (
        <div className="dashboard">
            <Menu />
            <div className="right_board">
                <BoardHeader title={t('admin.orders')} />
                <div className="content">
                    <p><strong>{t('admin.manage_orders')}</strong></p>
                    <label className="ml-0">
                        {t('admin.filter')} : <span className={pending ? "filter heavy" : "filter "} onClick={() => setPending(true)}>Pending</span> | <span className={!pending ? "filter heavy" : "filter"} onClick={() => setPending(false)}>Validated</span>
                    </label>
                    <ThreeDots visible={!orders} height="50" width="50" color="#1F90FA" radius="9" ariaLabel="three-dots-loading" />
                    {orders &&
                        <div className="users-table-container admin-orders-table-wrap">
                            <table className="users-table admin-orders-table">
                                <thead>
                                    <tr>
                                        <th>{t('admin.users')}</th>
                                        <th>REF</th>
                                        <th>{t('dashboard.created')}</th>
                                        <th>{t('dashboard.amount')}</th>
                                        <th>{t('dashboard.funds_sent')}</th>
                                        <th>Tx</th>
                                        <th className="center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orders.map(op => {
                                        const user = users[op.user_uuid];
                                        const kycClass = !user || !user.kyc_status ? 'warning' : user.kyc_status === 'APPROVED' ? 'success' : 'primary';

                                        return (
                                            <React.Fragment key={op.user_purchase_uuid}>
                                                <tr className="user-row">
                                                    <td data-label={t('admin.users')}>
                                                        {user ?
                                                            <div className="select_profile">
                                                                <div className="select_avatar" onClick={() => window.open(`/admin/user/${op.user_uuid}`)} style={{ backgroundImage: `url('https://api.dicebear.com/7.x/initials/svg?seed=${op.user_uuid}')` }}></div>
                                                                <div className="select_info">
                                                                    <span className="select_name">{user.firstname || '-'} {user.lastname || '-'}</span>
                                                                    <span className="select_email">{user.email}</span>
                                                                    <span className={`small_desc left ${kycClass}`}>KYC {user.kyc_status || t('dashboard.no_kyc')}</span>
                                                                </div>
                                                            </div>
                                                            :
                                                            <span>-</span>
                                                        }
                                                    </td>
                                                    <td data-label="REF"><strong>{op.reference}</strong></td>
                                                    <td data-label={t('dashboard.created')}>{formatDate(op.created_date)}</td>
                                                    <td data-label={t('dashboard.amount')}>
                                                        <span>{op.total_price_eur} € / {op.nb_token} CaâEuro</span>
                                                    </td>
                                                    <td data-label={t('dashboard.funds_sent')}>
                                                        {op.amount_received ?
                                                            <span className="primary">{op.amount_received} €</span>
                                                            :
                                                            <span className="pending-amount">{t('dashboard.awaiting_transfer')}</span>
                                                        }
                                                    </td>
                                                    <td data-label="Tx">
                                                        {op.tx_hash ?
                                                            <span className="tx_link" onClick={() => window.open(`${EXPLORER}/tx/${op.tx_hash}`)}>{shortHash(op.tx_hash)}</span>
                                                            :
                                                            <span className="pending-amount">-</span>
                                                        }
                                                    </td>
                                                    <td className="center" data-label="Action">
                                                        {pending && displayValidation !== op.user_purchase_uuid &&
                                                            <Button click={() => toggleValidation(op.user_purchase_uuid)} loading={loading} title={t('admin.confirm_order')} />
                                                        }
                                                    </td>
                                                </tr>
                                                {displayValidation === op.user_purchase_uuid &&
                                                    <tr className="admin-order-validation-row">
                                                        <td colSpan="7">
                                                            <div className="admin-order-validation-content">
                                                                <label>{t('admin.amount_received')}</label>
                                                                <div className="relative display-inline-block">
                                                                    <input type="number" className="semi" placeholder={"CâaEuro amount"} min="0" step="1" onChange={(e) => setAmount(e.target.value)} />
                                                                    <img src={LOGO_BLACK} className="caaeuro" alt="Logo CâaEuro" />
                                                                </div>
                                                                {!loading &&
                                                                    <div className="admin-order-validation-actions">
                                                                        <Button title={t('admin.validate')} click={() => validateOrder(op.user_uuid)} />
                                                                        <Button title={t('dashboard.cancel')} framed={true} click={() => toggleValidation(op.user_purchase_uuid)} />
                                                                    </div>
                                                                }
                                                                <div className="admin-order-validation-loader">
                                                                    <ThreeDots visible={loading} height="50" width="50" color="#1F90FA" radius="9" ariaLabel="three-dots-loading" />
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                }
                                            </React.Fragment>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            </div>
            <ToastContainer />
        </div>
    )
};

export default AdminOrders;